import React from 'react'
import "./Footer.css"
import logo from "./Header/AMZN_BIG.D-8fb0be81.png";
import { Link } from 'react-router-dom';
import LanguageIcon from "@mui/icons-material/Language";
import flagLogo from "./Header/2560px-Flag_of_the_United_States.svg.png";

function Footer() {
  return (
    <>
      <div className="top__footer">
        <div className="inner_top">
          <div className="top__title">
            <p>See personalized recommendations</p>
            <button className="button_top">Sign in</button>
            <div className="start__link">
              new Customer? <a href="/log up"> start here.</a>
            </div>
          </div>
        </div>
      </div>
      <div className="upper-text-container">
        <h2> Back to top</h2>
      </div>
      <div className="footer">
        <div className="sb__footer section__padding">
          <div className="sb__footer-links">
            <div className="sb__footer-links-div">
              <h4>Get to Know Us</h4>

              <a href="/">
                <p>Careers</p>
              </a>

              <a href="/">
                <p>Amazon Newsletter</p>
              </a>

              <a href="/">
                <p>About Amazon</p>
              </a>

              <a href="/">
                <p>Accessibility</p>
              </a>

              <a href="/">
                <p>Sustainability</p>
              </a>

              <a href="/">
                <p>press Center</p>
              </a>

              <a href="/">
                <p>Investor Relations</p>
              </a>

              <a href="/">
                <p>Amazon Devices</p>
              </a>

              <a href="/">
                <p>Amazon Science</p>
              </a>
            </div>
            <div className="sb__footer-links-div">
              <h4>Make Money with Us</h4>

              <a href="/">
                <p>Start Selling with Amazon</p>
              </a>

              <a href="/">
                <p>Sell apps on Amazon</p>
              </a>

              <a href="/">
                <p>Supply to Amazon</p>
              </a>

              <a href="/">
                <p>protect & Build your Brand</p>
              </a>

              <a href="/">
                <p>Become an Affilate</p>
              </a>

              <a href="/">
                <p>Become Delivery Driver</p>
              </a>

              <a href="/">
                <p>Become package Driver Business</p>
              </a>

              <a href="/">
                <p>Advertise Your products</p>
              </a>

              <a href="/">
                <p>Self-publish with Us</p>
              </a>

              <a href="/">
                <p>Host an AmazonHub</p>
              </a>

              <a href="/">
                <p>See More Ways to Make Money</p>
              </a>
            </div>
            <div className="sb__footer-links-div">
              <h4>Amazon payment products</h4>

              <a href="/">
                <p>Amazon Visa</p>
              </a>

              <a href="/">
                <p>Amazon Store Card</p>
              </a>

              <a href="/">
                <p>Amazon Secured Card</p>
              </a>

              <a href="/">
                <p>Amazon Business Card</p>
              </a>

              <a href="/">
                <p>Shop with points</p>
              </a>

              <a href="/">
                <p>Credit Card Marketplace</p>
              </a>

              <a href="/">
                <p>Reload Your Balance</p>
              </a>

              <a href="/">
                <p>Gift Cards</p>
              </a>

              <a href="/">
                <p>Amazon Currency Converter</p>
              </a>
            </div>

            <div className="sb__footer-links-div">
              <h4>Let Us Help You</h4>

              <a href="/">
                <p>Your Account</p>
              </a>

              <a href="/">
                <p>Your Orders</p>
              </a>

              <a href="/">
                <p>Shipping Rates & policies</p>
              </a>

              <a href="/">
                <p>Amazon prime</p>
              </a>

              <a href="/">
                <p>Returns & Replacements</p>
              </a>

              <a href="/">
                <p>Manage your Content and Devices</p>
              </a>

              <a href="/">
                <p>Your Recalls And product Safety Alerts</p>
              </a>

              <a href="/">
                <p>Help</p>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="sb__footer-below">
        <div className="">
          <Link to="/">
            <img className="header__logo" src={logo} alt="amazon-logo" />
          </Link>
        </div>
        <div className="two__buttons">
          <div className="button__container">
            <div className="button__first">
              <div>
                <LanguageIcon className="languge-icon"></LanguageIcon>
              </div>
              <div>
                <span className="button_one">English</span>
              </div>
            </div>
            <div className="buttone__second">
              <div>
                <img className="flag-logo" src={flagLogo} alt="usFlag" />
              </div>
              <div>
                <span className="button_two"> United States</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer



